// Types
import { FullEntityResponse } from 'app/modules/entities/responses';
import { ShortAlertResponse } from 'app/modules/alerts/types';

// Models
import { PaginationPayload } from 'app/shared/models';

export enum EntitiesActionTypes {
  EDIT_ENTITY = '@@entities/EDIT_ENTITY',
  EDIT_ENTITY_SUCCESS = '@@entities/EDIT_ENTITY_SUCCESS',

  RETRIEVE_ENTITY = '@@entities/RETRIEVE_ENTITY',
  RETRIEVE_ENTITY_SUCCESS = '@@entities/RETRIEVE_ENTITY_SUCCESS',

  RETRIEVE_ENTITY_ALERTS = '@@entities/RETRIEVE_ENTITY_ALERTS',
  RETRIEVE_ENTITY_ALERTS_SUCCESS = '@@entities/RETRIEVE_ENTITY_ALERTS_SUCCESS',

  CLEAR_ALL_ENTITY_STATE = '@@entities/CLEAR_ALL_ENTITY_STATE',
}

export interface EditEntityPayload {
  id: number | string;
  tags?: (number | string)[];
  comments?: string;
}

export interface EntityAlertsPayload extends PaginationPayload {
  entityExternalId: string;
  excluded_alert_ids?: number[];
}

export interface EditEntityResult {
  id: number;
}

export type EntityType = 'USER' | 'BUSINESS';

export interface Geolocation {
  city?: string;
  country?: string;
  geolocation_string?: string;
  ip_address?: string;
  latitude?: number;
  longitude?: number;
  postal_code?: string;
  subdivision?: string;
}

/**
 * @deprecated this is the legacy redux type. If not using redux, should use FullEntityResponse
 */
export interface EntityDetails extends FullEntityResponse {
  paginated_alerts: {
    alerts: ShortAlertResponse[];
    count: number;
  };
}

export interface EntityAlerts {
  count: number;
  alerts: ShortAlertResponse[];
}

export interface EntitiesState {
  details: EntityDetails;
}
